import React, { useContext } from "react";
import { Aside, CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { UserContext } from "../../../../core/security/UserProvider";
import { AddAssetNoteForm } from "./AddNoteForm";
import { NoteItem } from "./NoteItem";

export interface AddNoteButtonAsideProps {
    orderId: string;
    addNote(noteItem: NoteItem): void;
}

export const AddNoteButtonAside: React.FC<AddNoteButtonAsideProps> = ({
    orderId,
    addNote
}: AddNoteButtonAsideProps) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    const userContext = useContext(UserContext);

    const addNoteToContext = (content: string) => {
        addNote({
            author: userContext.name,
            creationDate: new Date().toISOString(),
            content
        });

        onClose();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <CommandBarButton icon="QuickNote" onClick={onOpen} text="Add note" testId="add-note" />
            <Aside type="form" headerText="Add note" isOpen={isOpen} onDismiss={onClose} isLightDismiss={true}>
                <AddAssetNoteForm orderId={orderId} onDismiss={onClose} onSubmit={addNoteToContext} />
            </Aside>
        </AuthorizationWrapper>
    );
};
